export const UI = 'ui-v4';

export const BUTTON_TOOLBAR = `${UI}-button-toolbar`;

export const BUTTON_GROUP = `${UI}-button-group`;
export const BUTTON_GROUP_LINK_BUTTONS = `${UI}-button-group-link-buttons`;

export const POPUP_WINDOW = `${UI}-popup-window`;
export const POPUP_WINDOW_EDIT = `${UI}-popup-window-edit`;
export const POPUP_WINDOW_VIEW = `${UI}-popup-window-view`;

export const TOOLTIP = `${UI}-tooltip`;
export const TOOLTIP_DEFAULT = `${UI}-tooltip-default`;
export const TOOLTIP_CLOSABLE = `${UI}-tooltip-closable`;
export const TOOLTIP_CLOSABLE_WRAPPER = `${UI}-tooltip-closable-wrapper`;
export const TOOLTIP_CLOSABLE_HEADER = `${UI}-tooltip-closable-header`;
export const TOOLTIP_CLOSABLE_BODY = `${UI}-tooltip-closable-body`;

export const POPUP = `${UI}-popup`;
export const POPUP_EDIT = `${UI}-popup-edit`;
export const POPUP_HIDDEN = `${UI}-popup-hidden`;
export const POPUP_VIEW = `${UI}-popup-view`;
export const POPUP_DEFAULT = `${UI}-popup-default`;
export const POPUP_INTENT_DANGER = `${UI}-popup-intent-danger`;
export const POPUP_INTENT_SUCCESS = `${UI}-popup-intent-success`;
export const POPUP_INTENT_WARNING = `${UI}-popup-intent-warning`;

export const POPOVER = `${UI}-popover`;
export const POPOVER_PORTAL = `${UI}-popover-portal`;

export const ICON = `${UI}-icon`;

export const MULTI_SELECT_SEARCH = `${UI}-multi-select-search`;
export const MULTI_SELECT_SEARCH_TITLE = `${UI}-multi-select-search-title`;
export const MULTI_SELECT_SEARCH_INPUT = `${UI}-multi-select-search-input`;
export const MULTI_SELECT_SEARCH_BUTTONS = `${UI}-multi-select-search-buttons`;
export const MULTI_SELECT_SEARCH_ITEMS_CONTAINER = `${UI}-multi-select-search-items-container`;

export const API_MULTI_SELECT_SEARCH = `${UI}-api-multi-select-search`;
export const API_MULTI_SELECT_SEARCH_LEFT = `${UI}-api-multi-select-search-left`;
export const API_MULTI_SELECT_SEARCH_RIGHT = `${UI}-api-multi-select-search-right`;
export const API_MULTI_SELECT_SEARCH_INPUT = `${UI}-api-multi-select-search-input`;
export const API_MULTI_SELECT_SEARCH_ITEMS_CONTAINER = `${UI}-api-multi-select-search-items-container`;
export const API_MULTI_SELECT_SEARCH_TAGS_CONTAINER = `${UI}-api-multi-select-search-tags-container`;

export const FILTERS = `${UI}-filters`;
export const FILTER_FILLED_FILTERABLE = `${UI}-filter-label-filled-filterable`;
export const FILTER_POPUP_LABEL = `${UI}-filter-popup-label`;
export const FILTER_POPUP_LABEL_ALLWAYS_VISIBLE = `${UI}-filter-popup-label-av`;
export const FILTER_GROUP = `${UI}-filter-group`;
export const FILTER_LABEL = `${UI}-filter-label`;
export const FILTER_FIELD = `${UI}-filter-field`;
export const FILTER_MULTI_SELECT = `${UI}-filter-multi-select-values`;
export const FILTER_MULTI_LIST = `${UI}-filter-multi-select-list`;

export const SHOW_ON_HOVER = `${UI}-show-on-hover`;
export const HOVER_CONTAINER = `${UI}-hover-container`;
export const HOVER_CONTAINER_CELL = `${UI}-hover-container-c`;
export const HOVER_ITEM_CONTAINER = `${UI}-hover-item-container`;
export const HOVER_DISABLE_ITEMS = `${UI}-hover-disabled-items`;
export const CHECKED_CONTAINER = `${UI}-checked-container`;
export const HIGHLIGHT_CONTAINER = `${UI}-highlight-container`;
export const CLICK_CONTAINER = `${UI}-click-container`;

export const INVERSE_CONTAINER_TRUE = `${UI}-inverse-inverse`;
export const INVERSE_CONTAINER_FALSE = `${UI}-inverse-default`;

export const BUTTON = `${UI}-button`;
export const BUTTON_ICON_LEFT = `${UI}-button-icon-left`;
export const BUTTON_ICON_RIGHT = `${UI}-button-icon-right`;
export const BUTTON_TEXT = `${UI}-button-text`;
export const BUTTON_INVERSE = `${UI}-button-inverse`;
export const BUTTON_FILL = `${UI}-button-fill`;
export const BUTTON_DEFAULT_WIDTH = `${UI}-button-no-default-width`;
export const BUTTON_DROPDOWN = `${UI}-button-dropdown`;
export const BUTTON_NO_FOCUS = `${UI}-button-no-focus`;
export const BUTTON_NO_PADDING = `${UI}-button-no-padding`;
export const BUTTON_ICON_ONLY = `${UI}-button-icon-only`;
export const BUTTON_TEXT_CENTER = `${UI}-button-text-center`;
export const BUTTON_INHERIT_COLOR = `${UI}-button-inherit-color`;
export const BUTTON_DEFAULT = `${UI}-button-default`;
export const BUTTON_PRIMARY = `${UI}-button-primary`;
export const BUTTON_NAVBAR = `${UI}-button-navbar`;
export const BUTTON_TOOL = `${UI}-button-tool`;
export const BUTTON_TOOL_ACTIVE = `${UI}-button-tool-active`;
export const BUTTON_CLOSE = `${UI}-button-close`;
export const BUTTON_FILTER = `${UI}-button-filter`;
export const BUTTON_LINK = `${UI}-button-link`;
export const BUTTON_LINK_NO_PADDING = `${UI}-button-link-no-padding`;
export const BUTTON_ICON_LINK = `${UI}-button-icon-link`;
export const BUTTON_PRIMARY_DANGER = `${UI}-button-primary-danger`;
export const BUTTON_DEFAULT_DANGER = `${UI}-button-default-danger`;
export const BUTTON_LINK_DANGER = `${UI}-button-link-danger`;

export const BUTTON_LINK_NAVBAR = `${UI}-button-link-navbar`;

export const LINK = `${UI}-link`;
export const LINK_ASYNC_LOADING = `${UI}-link-async-loading`;
export const LINK_ASYNC_CHILDREN = `${UI}-link-async-children`;

export const INPUT_READONLY_STANDARD = `${UI}-readonly-standard`;

export const MONTH_PICKER = `${UI}-month-picker`;
export const MONTH_PICKER_HEADER = `${UI}-month-picker-header`;
export const MONTH_PICKER_HEADER_YEAR = `${UI}-month-picker-header-year`;
export const MONTH_PICKER_MONTHS = `${UI}-month-picker-months`;
export const MONTH_PICKER_MONTH = `${UI}-month-picker-month`;
export const MONTH_PICKER_MONTH_TD = `${UI}-month-picker-month-td`;

export const DATE_PICKER = `${UI}-date-picker`;
export const DATE_PICKER_NEW = `${UI}-date-picker-new`;
export const DATE_PICKER_HEADER = `${UI}-date-picker-header`;
export const DATE_PICKER_HEADER_1 = `${UI}-date-picker-header-1`;
export const DATE_PICKER_HEADER_2 = `${UI}-date-picker-header-2`;
export const DATE_PICKER_DAYS = `${UI}-date-picker-days`;
export const DATE_PICKER_DAY = `${UI}-date-picker-day`;
export const DATE_PICKER_DAY_CM = `${UI}-date-picker-day-cm`;
export const DATE_PICKER_DAY_TD = `${UI}-date-picker-day-td`;
export const DATE_PICKER_DAY_NAMES = `${UI}-date-picker-day-names`;
export const DATE_PICKER_TIME = `${UI}-date-picker-time`;

export const TIME_PICKER = `${UI}-time-picker`;
export const TIME_PICKER_HOURS_WRAPPER = `${UI}-time-picker-hours-wrapper`;
export const TIME_PICKER_MINUTES_WRAPPER = `${UI}-time-picker-minutes-wrapper`;
export const TIME_PICKER_HOUR_ROW = `${UI}-time-picker-hour-row`;
export const TIME_PICKER_MINUTE_ROW = `${UI}-time-picker-minute-row`;
export const TIME_PICKER_HOUR = `${UI}-time-picker-hour`;
export const TIME_PICKER_MINUTE = `${UI}-time-picker-minute`;
export const TIME_PICKER_ACTIVE = `${UI}-time-picker-active`;
export const TIME_PICKER_LABEL = `${UI}-time-picker-label`;
export const TIME_PICKER_COL_SEPARATOR = `${UI}-time-picker-col-separator`;

export const DAY_WEEK_PICKER = `${UI}-day-week-picker`;
export const DAY_WEEK_PICKER_NEW = `${UI}-day-week-picker-new`;
export const DAY_WEEK_PICKER_HEADER = `${UI}-day-week-picker-header`;
export const DAY_WEEK_PICKER_HEADER_1 = `${UI}-day-week-picker-header-1`;
export const DAY_WEEK_PICKER_HEADER_2 = `${UI}-day-week-picker-header-2`;
export const DAY_WEEK_PICKER_HEADER_MONTH_NAME = `${UI}-day-week-picker-header-month-name`;
export const DAY_WEEK_PICKER_HEADER_YEAR = `${UI}-day-week-picker-header-year`;
export const DAY_WEEK_PICKER_DAYS = `${UI}-day-week-picker-days`;
export const DAY_WEEK_PICKER_DAY = `${UI}-day-week-picker-day`;
export const DAY_WEEK_PICKER_DAY_ANOTHER_MONTH = `${UI}-day-week-picker-day-another-month`;
export const DAY_WEEK_PICKER_DAY_CM = `${UI}-day-week-picker-day-cm`;
export const DAY_WEEK_PICKER_DAY_TD = `${UI}-day-week-picker-day-td`;
export const DAY_WEEK_PICKER_DAY_HIGHLIGHTED = `${UI}-day-week-picker-day-highlighted`;
export const DAY_WEEK_PICKER_DAY_NAMES = `${UI}-day-week-picker-day-names`;
export const WEEKS_PICKER = `${UI}-weeks-picker`;
export const WEEK_PICKER = `${UI}-week-picker`;
export const DAY_WEEK_PICKER_TIME = `${UI}-day-week-picker-time`;

export const DAY_MONTH_INPUT = `${UI}-day-month-input`;

export const DURATION_INPUT = `${UI}-duration-input`;

export const FORM_DATETIME_ITEM = `form-datetime-item`;
export const DATE_TIME_WRAPPER = `${UI}-date-time-wrapper`;
export const DATE_TIME_INPUT = `${UI}-date-time-input`;
export const STRING_DATE_TIME_INPUT = `${UI}-string-date-time-input`;

export const DATE_INPUT = `${UI}-date-input`;
export const STRING_DATE_INPUT = `${UI}-string-date-input`;
export const DATE_INPUT_INPUT = `${UI}-date-input-input`;
export const DATE_INPUT_POPUP = `${UI}-date-input-popup`;

export const CHECKBOX = `${UI}-checkbox`;
export const FORM_CHECKBOX_ITEM = `form-checkbox-item`;
export const FORM_CHECKBOX_INPUT_ITEM = `form-checkbox-input-item`;
export const CHECKBOX_BUTTON = `${UI}-checkbox-button`;
export const CHECKBOX_BUTTON_NO_BUTTON = `${UI}-checkbox-button-no-button`;
export const CHECKBOX_BUTTON_DISABLED = `${UI}-checkbox-button-disabled`;
export const CHECKBOX_LABEL = `${UI}-checkbox-label`;
export const CHECKBOX_DISABLED = `${UI}-checkbox-disabled`;
export const CHECKBOX_CHECKED = `${UI}-checkbox-checked`;
export const CHECKBOX_UNCHECKED = `${UI}-checkbox-unchecked`;
export const CHECKBOX_INTERMEDIATE = `${UI}-checkbox-intermediate`;
export const CHECKBOX_OW = `${UI}-checkbox-ow`;
export const CHECKBOX_IN = `${UI}-checkbox-in`;
export const CHECKBOX_WRAPPER = `${UI}-checkbox-wrapper`;

export const CHECKBOX_BODY = `${UI}-checkbox-body`;

export const RADIO = `${UI}-radio`;
export const RADIO_CONTROL_INDICATOR = `${UI}-radio-control-indicator`;
export const RADIO_BUTTON = `${UI}-radio-button`;
export const RADIO_BUTTON_NO_BUTTON = `${UI}-radio-button-no-button`;
export const RADIO_DISABLED = `${UI}-radio-disabled`;

export const RADIO_GROUP = `${UI}-radio-group`;
export const RADIO_GROUP_HORIZONTAL = `${UI}-radio-group-horizontal`;

export const TEXT_AREA_INPUT = `${UI}-text-area-input`;

export const INPUT_ADDONS = `${UI}-input-addons`;
export const INPUT_ADDONS_HAS_ADDON_AFTER = `${UI}-input-addons-has-addon-after`;
export const INPUT_ADDONS_COMPACT = `${UI}-input-addons-compact`;
export const INPUT_ADDONS_NO_COMPACT = `${UI}-input-addons-no-compact`;
export const INPUT_ADDONS_LIMITED_SIZE = `${UI}-input-addons-limited-size`;
export const INPUT_ADDONS_INPUT = `${UI}-input-addons-input`;
export const INPUT_ADDONS_ADDON_AFTER = `${UI}-input-addons-addon-after`;

export const FIELD_INPUT = `${UI}-field-input`;
export const FIELD_INPUT_DISABLED = `${UI}-field-input-disabled`;
export const FIELD_INPUT_READONLY = `${UI}-field-input-readonly`;
export const FIELD_INPUT_VALUE_ERROR = `${UI}-field-input-value-error`;
export const FIELD_INPUT_ALIGN_RIGHT = `${UI}-field-input-align-right`;
export const FIELD_INPUT_HAS_RIGHT_ACTION = `${UI}-field-input-has-right-action`;
export const FIELD_INPUT_HAS_RIGHT_ICON = `${UI}-field-input-has-right-icon`;
export const FIELD_INPUT_RIGHT_ELEMENT = `${UI}-field-input-right-element`;
export const FIELD_INPUT_ACTION = `${UI}-field-input-action`;
export const FIELD_INPUT_LEFT = `${UI}-field-input-left`;
export const FIELD_INPUT_LEFT_PLACEHOLDER = `${UI}-field-input-left-pl`;
export const FIELD_HAS_INPUT_ACTION = `${UI}-field-has-input-action`;
export const FIELD_HAS_LEFT = `${UI}-field-input-has-left`;
export const FIELD_INPUT_GROUP = `${UI}-field-input-group`;
export const FIELD_SIZE_2 = `${UI}-field-size-2`;
export const FIELD_SIZE_3 = `${UI}-field-size-3`;
export const FIELD_SIZE_4 = `${UI}-field-size-4`;
export const LIMIT_DATE_TIME_SIZE = `${UI}-limit-date-time-size`;

export const INPUT = `${UI}-input`;

export const STRING_INPUT = `${UI}-string-input`;

export const TIME_INPUT = `${UI}-time-input`;

export const NUMBER_INPUT = `${UI}-number-input`;

export const MULTI_FILE_INPUT = `${UI}-multi-file-input`;
export const MULTI_FILE_INPUT_FILES = `${UI}-multi-file-input-files`;

export const FILE_INPUT = `${UI}-file-input`;
export const FILE_INPUT_FILE_BUTTON = `${UI}-file-input-file-button`;
export const FILE_INPUT_FILENAME_WRAPPER = `${UI}-file-input-filename-wrapper`;
export const FILE_INPUT_FILENAME = `${UI}-file-input-filename`;
export const FILE_INPUT_EXTENSION = `${UI}-file-input-extension`;
export const FILE_INPUT_FILENAME_UPLOADING = `${UI}-file-input-filename-uploading`;
export const FILE_INPUT_UPLOADING = `${UI}-file-input-uploading`;
export const FILE_INPUT_DRAGGING = `${UI}-file-input-dragging`;
export const FILE_INPUT_INPUT = `${UI}-file-input-input`;
export const FILE_INPUT_ACTION = `${UI}-file-input-action`;

export const BASE_AUTOCOMPLETE = `${UI}-base-autocomplete`;
export const BASE_AUTOCOMPLETE_TREE = `${UI}-base-autocomplete-tree`;
export const SELECTBOX = `${UI}-selectbox`;
export const AUTOCOMPLETE = `${UI}-autocomplete`;
export const FULLTEXT = `${UI}-fulltext`;
export const FULLTEXT_LEFT_ICON = `${UI}-fulltext-left-icon`;

export const VALUE_INPUT_DETAIL = `${UI}-value-input-detail`;
export const VALUE_INPUT_DETAIL_CONTENT = `${UI}-value-input-detail-content`;
export const VALUE_INPUT_DETAIL_EXTRA = `${UI}-value-input-detail-extra`;

export const AUTOCOMPLETE_LATEST_ITEMS = `${UI}-autocomoplete-latest-items`;

export const SWITCH = `${UI}-switch`;
export const SWITCH_IN = `${UI}-switch-in`;
export const SWITCH_SW = `${UI}-switch-sw`;
export const SWITCH_DISABLED = `${UI}-switch-disabled`;
export const SWITCH_TRACK = `${UI}-switch-track`;
export const SWITCH_OW = `${UI}-switch-ow`;
export const SWITCH_WRAPPER = `${UI}-switch-wrapper`;
export const SWITCH_CHECKED = `${UI}-switch-checked`;
export const SWITCH_LR = `${UI}-switch-lr`;
export const SWITCH_UNCHECKED = `${UI}-switch-unchecked`;

export const PROGRESS_BAR = `${UI}-progress-bar`;
export const PROGRESS_BAR_SMALL = `${UI}-progress-bar-small`;
export const PROGRESS_BAR_LARGE = `${UI}-progress-bar-large`;
export const PROGRESS_BAR_METER = `${UI}-progress-bar-meter`;
export const PROGRESS_BAR_INFINITE = `${UI}-progress-bar-infinite`;
export const PROGRESS_BAR_INFINITE_AN = `${UI}-progress-bar-infinite-an`;
export const PROGRESS_BAR_CONTENT = `${UI}-progress-bar-content`;

export const RZ_WRAPPER = `${UI}-rz-wrapper`;
export const RZ_WRAPPER_CONTENT = `${UI}-rz-wrapper-content`;
export const RZ_WRAPPER_EXTRA = `${UI}-rz-wrapper-extra`;
export const RZ_WRAPPER_MPZ = `${UI}-rz-wrapper-mpz`;
export const RZ_WRAPPER_NO_MPZ = `${UI}-rz-wrapper-no-mpz`;
export const RZ_WRAPPER_RZ = `${UI}-rz-wrapper-rz`;
export const RZ_WRAPPER_ZNACKA = `${UI}-rz-wrapper-znacka`;
export const RZ_WRAPPER_NO_RADIUS = `${UI}-rz-wrapper-no-radius`;
export const RZ_WRAPPER_SMALL = `${UI}-rz-wrapper-small`;

export const INPUT_RANGE = `${UI}-input-range`;
export const DATE_INPUT_RANGE = `${UI}-date-input-range`;
export const INPUT_RANGE_CENTER_VALUES = `${UI}-input-range-center-values`;
export const INPUT_RANGE_ICON = `${UI}-input-range-icon`;

export const INPUT_GROUP = `${UI}-input-group`;
export const INPUT_GROUP_INPUT = `${UI}-input-group-input`;
export const INPUT_GROUP_RIGHT = `${UI}-input-group-right`;
export const INPUT_GROUP_LEFT = `${UI}-input-group-left`;
export const INPUT_GROUP_CENTER_VALUES = `${UI}-input-group-center-values`;

//Colormenu-wysiwig
export const COLOR_MENU = `${UI}-color-menu`;
export const COLOR_MENU_GRID = `${UI}-color-menu-grid`;
export const COLOR_BUTTON = `${UI}-color-button`;
export const COLOR_BUTTON_ACTIVE = `${UI}-color-button-active`;
export const SET_COLOR_BUTTON_NULL = `${UI}-set-color-button-null`;

//HTML Editor-wysiwyg
export const HTML_EDITOR = `${UI}-html-editor`;

export const MENU = `${UI}-menu`;
export const MENU_ITEM = `${UI}-menu-item`;
export const MENU_ITEM_DISABLED = `${UI}-menu-item--disabled`;
export const MENU_DIVIDER = `${UI}-menu-divider`;
export const MENU_SECTION = `${UI}-menu-section`;
export const MENU_ITEM_CONTENT = `${UI}-menu-item-content`;
export const MENU_ITEM_ICON = `${UI}-menu-item-icon`;
export const MENU_ITEM_TEXT = `${UI}-menu-item-text`;
export const MENU_ITEM_CHEVRON = `${UI}-menu-item-chevron`;
export const MENU_ITEM_SUBMENU = `${UI}-menu-item-submenu`;

export const FORMATTED_TEXT = `${UI}-formatted-text`;

/**
 * Pro dialogy, které mají být vždy nejvýše - typově pouze confirm, error apod.
 */
export const DIALOG_TOP = `${UI}-dialog-top`;

export const PORTAL_DIALOG = `${UI}-portal-dialog`;
export const PORTAL_DIALOG_OVERLAY = `${UI}-portal-dialog-overlay`;
export const PORTAL_DIALOG_BACKDROP = `${UI}-portal-dialog-backdrop`;
export const PORTAL_DIALOG_CONTAINER = `${UI}-portal-dialog-container`;
export const PORTAL_DIALOG_INLINE_WRAPPER = `${UI}-portal-dialog-inline-wrapper`;

export const DIALOG = `${UI}-dialog`;
export const DIALOG_FULLSCREEN = `${UI}-dialog-fullscreen`;
export const DIALOG_SIZE_DYNAMIC = `${UI}-dialog-size-dynamic`;
export const DIALOG_FORMGRID = `${UI}-dialog-formgrid`;
export const DIALOG_ON_TOP = `${UI}-dialog-on-top`;
export const DIALOG_SIZE_DEFAULT = `${UI}-dialog-size-default`;
export const DIALOG_SIZE_MD = `${UI}-dialog-size-md`;
export const DIALOG_SIZE_LG = `${UI}-dialog-size-lg`;
export const DIALOG_SIZE_XL = `${UI}-dialog-size-xl`;
export const DIALOG_SIZE_XXL = `${UI}-dialog-size-xxl`;
export const DIALOG_SIZE_DBLCOL = `${UI}-dialog-size-dbl-col`;
export const DIALOG_SHOW_TOP_SCROLL_INDICATOR = `${UI}-dialog-show-top-scroll-indicator`;
export const DIALOG_SHOW_BOTTOM_SCROLL_INDICATOR = `${UI}-dialog-show-bottom-scroll-indicator`;
export const DIALOG_BODY = `${UI}-dialog-body`;
export const DIALOG_BODY_DISABLE_SCROLL = `${UI}-dialog-body-disable-scroll`;
export const DIALOG_FOOTER = `${UI}-dialog-footer`;
export const DIALOG_FOOTER_ACTIONS = `${UI}-dialog-footer-actions`;
export const DIALOG_FOOTER_EXTRA = `${UI}-dialog-footer-extra`;
export const DIALOG_HEADER = `${UI}-dialog-header`;
export const DIALOG_HEADER_HEADING = `${UI}-dialog-header-heading`;
export const DIALOG_HEADER_WRAPPER = `${UI}-dialog-header-wrapper`;
export const DIALOG_HEADER_TITLE = `${UI}-dialog-header-title`;
export const DIALOG_HEADER_EXTRA_RIGHT = `${UI}-dialog-header-title-extra-right`;
export const DIALOG_HEADER_CLOSE = `${UI}-dialog-header-close`;
export const WAITING_DIALOG = `${UI}-waiting-dialog`;
export const WAITING_DIALOG_BODY = `${UI}-waiting-dialog-body`;
export const WAITING_DIALOG_TITLE = `${UI}-waiting-dialog-title`;

export const WIZARD_FORM = `${UI}-wizard-form`;
export const WIZARD_FORM_STEPS = `${UI}-wizard-form-steps`;
export const WIZARD_FORM_CONTENT = `${UI}-wizard-form-content`;

export const WIZARD_STEPS = `${UI}-wizard-steps`;
export const WIZARD_STEP = `${UI}-wizard-step`;
export const WIZARD_STEP_ACTIVE = `${UI}-wizard-step-active`;
export const WIZARD_STEP_DISABLED = `${UI}-wizard-step-disabled`;
export const WIZARD_STEP_VISITED = `${UI}-wizard-step-visited`;
export const WIZARD_STEP_WAIT = `${UI}-wizard-step-wait`;
export const WIZARD_STEP_ERROR = `${UI}-wizard-step-error`;
export const WIZARD_STEP_DIVIDER = `${UI}-wizard-step-divider`;

export const INVERSE_SCROLL_CONTAINER = `${UI}-inverse-scroll-container`;

export const TITLE = `${UI}-title`;
export const TITLE_H1 = `${UI}-title-h1`;
export const TITLE_H2 = `${UI}-title-h2`;
export const TITLE_H3 = `${UI}-title-h3`;
export const TITLE_H4 = `${UI}-title-h4`;
export const TITLE_H5 = `${UI}-title-h5`;
export const TITLE_WRAPPER = `${UI}-title-wrapper`;
export const TITLE_TITLE = `${UI}-title-title`;
export const TITLE_CONTENT = `${UI}-title-content`;
export const TITLE_ICON = `${UI}-title-icon`;
export const TITLE_EXTRA = `${UI}-title-extra`;
export const TITLE_EXTRA_LEFT = `${UI}-title-extra-left`;

export const TEXT_TYPE_CARD = `${UI}-text-type-card`;
export const TEXT_TYPE_BLOCK = `${UI}-text-type-block`;
export const TEXT_TYPE_LIST = `${UI}-text-type-list`;
export const TEXT_TYPE_LIST_ITEM = `${UI}-text-type-list-item`;
export const TEXT_TYPE_DETAIL = `${UI}-text-type-detail`;
export const TEXT_TYPE_DETAIL2 = `${UI}-text-type-detail2`;
export const TEXT_TYPE_DETAIL3 = `${UI}-text-type-detail3`;
export const TEXT_TYPE_PAGE = `${UI}-text-type-page`;
export const TEXT_TYPE_PAGE2 = `${UI}-text-type-page2`;
export const TEXT_TYPE_SECTION = `${UI}-text-type-section`;
export const TEXT_TYPE_VALUE = `${UI}-text-type-value`;
export const TEXT_TYPE_PAGE3 = `${UI}-text-type-page3`;
export const TEXT_TYPE_SIDEPANEL = `${UI}-text-type-sidepanel`;
export const TEXT_TYPE_TILE = `${UI}-text-type-tile`;
export const TEXT_TYPE_TILE_VALUE = `${UI}-text-type-tile-value`;

export const LAYOUT = `${UI}-layout`;
export const LAYOUT_HEADER = `${UI}-layout-header`;
export const LAYOUT_FOOTER = `${UI}-layout-footer`;
export const LAYOUT_CONTENT = `${UI}-layout-content`;
export const LAYOUT_DISABLE_SCROLL = `${UI}-layout-disable-scroll`;
export const LAYOUT_H100 = `${UI}-layout-h100`;
export const LAYOUT_DEFAULT = `${UI}-m-default`;
export const LAYOUT_VIEW_DETAIL = `${UI}-m-view-detail`;

export const APP_ERROR = `${UI}-app-error`;
export const APP_ERROR_NO_CENTER = `${UI}-app-error-no-center`;
export const APP_ERROR_ICON = `${UI}-app-error-icon`;
export const APP_ERROR_MESSAGE = `${UI}-app-error-message`;
export const APP_ERROR_CONTENT = `${UI}-app-error-content`;

export const DIVIDER = `${UI}-divider`;
export const DIVIDER_MODE_DEFAULT = `${UI}-divider-mode-default`;
export const DIVIDER_MODE_DASHED = `${UI}-divider-mode-dashed`;
export const DIVIDER_TYPE_LINE = `${UI}-divider-type-line`;
export const DIVIDER_TYPE_DOT = `${UI}-divider-type-dot`;
export const DIVIDER_VERTICAL = `${UI}-divider-vertical`;
export const DIVIDER_HORIZONTAL = `${UI}-divider-horizontal`;
export const DIVIDER_DEFAULT = `${UI}-divider-default`;
export const DIVIDER_SECONDARY = `${UI}-divider-secondary`;
export const DIVIDER_WARNING = `${UI}-divider-warning`;

export const SPACE = `${UI}-space`;
export const SPACE_VERTICAL = `${UI}-space-vertical`;
export const SPACE_HORIZONTAL = `${UI}-space-horizontal`;
export const SPACE_HSIZE_1 = `${UI}-space-hsize-1`;
export const SPACE_HSIZE_2 = `${UI}-space-hsize-2`;
export const SPACE_HSIZE_3 = `${UI}-space-hsize-3`;
// export const SPACE_HSIZE_4 = `${UI}-space-hsize-4`;
// export const SPACE_HSIZE_5 = `${UI}-space-hsize-5`;
export const SPACE_VSIZE_1 = `${UI}-space-vsize-1`;
export const SPACE_VSIZE_2 = `${UI}-space-vsize-2`;
export const SPACE_VSIZE_3 = `${UI}-space-vsize-3`;
// export const SPACE_VSIZE_4 = `${UI}-space-vsize-4`;
// export const SPACE_VSIZE_5 = `${UI}-space-vsize-5`;
export const SPACE_HORIZONTAL_WRAP = `${UI}-space-horizontal-wrap`;

export const ROW = `${UI}-row`;
export const COL = `${UI}-col`;
export const GRID_COL = `col`;
export const GRID_NO_GUTTERS = `no-gutters`;
export const GRID_ROW = `row`;

export const CALLOUT = `${UI}-callout`;
export const CALLOUT_HAS_TITLE = `${UI}-callout-has-title`;
export const CALLOUT_CONTENT_WRAPPER = `${UI}-callout-content-wrapper`;
export const CALLOUT_ICON = `${UI}-callout-icon`;
export const CALLOUT_TITLE = `${UI}-callout-title`;
export const CALLOUT_CONTENT = `${UI}-callout-content`;
export const CALLOUT_EXTRA = `${UI}-callout-extra`;
export const CALLOUT_BODY = `${UI}-callout-body`;
export const CALLOUT_NONE = `${UI}-callout-intent-none`;
export const CALLOUT_DEFAULT = `${UI}-callout-intent-default`;
export const CALLOUT_INFO = `${UI}-callout-intent-info`;
export const CALLOUT_PRIMARY = `${UI}-callout-intent-primary`;
export const CALLOUT_SUCCESS = `${UI}-callout-intent-success`;
export const CALLOUT_DANGER = `${UI}-callout-intent-danger`;
export const CALLOUT_WARNING = `${UI}-callout-intent-warning`;
export const CALLOUT_FILTER = `${UI}-callout-intent-filter`;

export const CARD = `${UI}-card`;
export const CARD_MODE_EDIT = `${UI}-card-mode-edit`;
export const CARD_MODE_VIEW = `${UI}-card-mode-view`;
export const CARD_MODE_SECTION = `${UI}-card-mode-section`;
export const CARD_MODE_SUBSECTION = `${UI}-card-mode-subsection`;
export const CARD_MODE_FILTER = `${UI}-card-mode-filter`;
export const CARD_MODE_DEFAULT = `${UI}-card-mode-default`;
export const CARD_NONE = `${UI}-card-intent-none`;
export const CARD_INFO = `${UI}-card-intent-info`;
export const CARD_DANGER = `${UI}-card-intent-danger`;
export const CARD_SUCCESS = `${UI}-card-intent-success`;
export const CARD_INACTIVE = `${UI}-card-intent-inactive`;
export const CARD_DEFAULT = `${UI}-card-intent-default`;
export const CARD_WARNING = `${UI}-card-intent-warning`;
export const CARD_HAS_TITLE = `${UI}-card-has-title`;
export const CARD_HAS_BODY = `${UI}-card-has-body`;
export const CARD_NONE_TITLE = `${UI}-card-none-title`;
export const CARD_HEADER = `${UI}-card-header`;
export const CARD_HEADER_TITLE = `${UI}-card-header-title`;
export const CARD_HEADER_TITLE_NO_WRAP = `${UI}-card-header-title-no-wrap`;
export const CARD_HEADER_EXTRA = `${UI}-card-header-extra`;
export const CARD_BODY = `${UI}-card-body`;
export const CARD_SIDE_HEADER = `${UI}-card-side-header`;

export const NO_SCROLL = `${UI}-no-scroll`;

export const NO_USER_SELECT = `${UI}-no-user-select`;

export const GROUP_CONTAINER = `${UI}-group-container`;
export const GROUP_CONTAINER_EMPTY = `${UI}-group-container-empty`;
export const GROUP_CONTAINER_INVERSE = `${UI}-group-container-inverse`;
export const DEFAULT_GROUP_CONTAINER = `${UI}-default-group-container`;
export const NO_HEADER_GROUP_CONTAINER = `${UI}-no-header-group-container`;
export const TAG_HEADER_GROUP_CONTAINER = `${UI}-tag-header-group-container`;
export const GROUP_CONTAINER_HEADER = `${UI}-group-container-header`;
export const GROUP_CHECKER_CONT = `${UI}-group-checker-cont`;

export const GROUP_CONTAINER_HEADER_TITLE = `${UI}-group-container-header-title`;
export const GROUP_CONTAINER_HEADER_CONTENT = `${UI}-group-container-header-content`;
export const GROUP_CONTAINER_HEADER_TITLE_NO_WRAP = `${UI}-group-container-header-title-no-wrap`;
export const GROUP_CONTAINER_HEADER_EXTRA = `${UI}-group-container-header-extra`;
export const GROUP_CONTAINER_BODY = `${UI}-group-container-body`;
export const GROUP_CONTAINER_BODY_PADDING = `${UI}-group-container-body-padding`;

export const LIST = `${UI}-list`;
export const LIST_CONTAINER = `${UI}-list-container`;
export const LIST_NO_PADDING = `${UI}-list-no-padding`;
export const LIST_NO_TB_ROWS = `${UI}-list-no-tb-rows`;
export const LIST_COMPACT = `${UI}-list-compact`;
export const LIST_MODE_EDIT = `${UI}-list-mode-edit`;
export const LIST_MODE_VIEW = `${UI}-list-mode-view`;
export const LIST_MODE_DEFAULT = `${UI}-list-mode-default`;
export const LIST_MODE_LABELS = `${UI}-list-mode-labels`;
export const LIST_MODE_CARDS = `${UI}-list-mode-cards`;
export const LIST_MODE_INPUT = `${UI}-list-mode-input`;
export const LIST_MODE_GRID = `${UI}-list-mode-grid`;
export const LIST_MODE_FORM = `${UI}-list-mode-form`;

export const NAVBAR_BRAND = `${UI}-navbar-brand`;
export const NAVBAR_CENTER = `${UI}-navbar-center`;
export const NAVBAR_RIGHT = `${UI}-navbar-right`;
export const NAVBAR_RIGHT_CONTENT = `${UI}-navbar-right-content`;
export const NAVBAR = `${UI}-navbar`;
export const NAVBAR_MENU_ICON = `${UI}-navbar-menu-icon`;
export const NAVBAR_CONTENT = `${UI}-navbar-content`;
export const NAVBAR_EXTRA = `${UI}-navbar-extra`;
export const NAVBAR_MENU_CONTAINER = `${UI}-navbar-menu-container`;
export const NAVBAR_MENU_CONTENT = `${UI}-navbar-menu-content`;
export const NAVBAR_MENU_CLOSE_BUTTON = `${UI}-navbar-menu-close-button`;
export const NAVBAR_MENU_POPOVER = `${UI}-navbar-menu-popover`;
export const NAVBAR_MENU_POPOVER_SHOW_SHADOW = `${UI}-navbar-menu-popover--show-shadow`;
export const NAVBAR_ACTION_ITEM_MENU_POPOVER = `${UI}-navbar-action-item-menu-popover`;
export const NAVBAR_ACTION_ITEM_MENU_POPOVER_CONTENT = `${UI}-navbar-action-item-menu-popover-c`;
export const NAVBAR_ACTION_ITEM_MENU_PINNED = `${UI}-navbar-action-item-menu-pinned`;
export const NAVBAR_MENU_ITEM_CONTAINER = `${UI}-navbar-menu-item-container`;
export const NAVBAR_USER_MENU = `${UI}-navbar-user-menu`;
export const NAVBAR_USER_MENU_BUTTON = `${UI}-navbar-user-menu-button`;
export const NAVBAR_MENU_ITEM = `${UI}-navbar-menu-item`;
export const NAVBAR_MENU_ITEM_SEPARATOR = `${UI}-navbar-menu-item-separator`;
export const NAVBAR_MENU_SEPARATOR = `${UI}-navbar-menu-separator`;
export const NAVBAR_MENU_SCROLL_CONTAINER = `${UI}-navbar-menu-scroll-container`;
export const NAVBAR_MENU_ITEM_CURRENT = `${UI}-navbar-menu-item-current`;

export const NAVBAR_SIDEPANEL_CONTROLS = `${UI}-navbar-sidepanel-controls`;
export const NAVBAR_SIDEPANEL_CONTROL_BASIC = `${UI}-navbar-sidepanel-control_basic`;
export const NAVBAR_SIDEPANEL_CONTROL_ACTIVE = `${UI}-navbar-sidepanel-control_active`;
export const NAVBAR_SIDEPANEL_CONTENT = `${UI}-navbar-sidepanel-content`;
export const NAVBAR_SIDEPANEL_ACTIVE_INDICATOR = `${UI}-navbar-sidepanel-active_indicator`;

export const LIST_PAGE_LAYOUT = `${UI}-list-page-layout`;
export const LIST_PAGE_CONTENT_WRAPPER = `${UI}-list-page-wrapper`;
export const LIST_PAGE_CONTENT_PADDING = `${UI}-list-page-padding`;
export const LIST_PAGE_CONTENT_SCROLLABLE = `${UI}-list-page-scrollable`;
export const LIST_PAGE_CONTENT_SC_WRAPPER = `${UI}-list-page-content-sc-wrapper`;

export const BLANK_PAGE_LAYOUT = `${UI}-blank-page-layout`;
export const BLANK_PAGE_CONTENT_WRAPPER = `${UI}-blank-page-content-wrapper`;
export const BLANK_PAGE_CONTENT_SC_WRAPPER = `${UI}-blank-page-content-sc-wrapper`;
export const BLANK_PAGE_CONTENT_SC_WRAPPER_NO = `${UI}-blank-page-content-sc-wrapper-no`;

export const DETAIL_PAGE_LAYOUT = `${UI}-detail-page-layout`;
export const DETAIL_PAGE_HEADER_TOP = `${UI}-detail-page-header-top`;
export const DETAIL_PAGE_HEADER_LEFT = `${UI}-detail-page-header-left`;
export const DETAIL_PAGE_HEADER = `${UI}-detail-page-header`;
export const DETAIL_PAGE_HEADER_DEFAULT = `${UI}-detail-page-header-default`;
export const DETAIL_PAGE_HEADER_SECONDARY = `${UI}-detail-page-header-secondary`;
export const DETAIL_PAGE_CONTENT_SC_WRAPPER = `${UI}-detail-page-content-sc-wrapper`;
export const DETAIL_PAGE_CONTENT_NOSCROLL = `${UI}-detail-page-no-scoll`;
export const DETAIL_PAGE_CONTENT_WRAPPER = `${UI}-detail-page-content-wrapper`;
export const DETAIL_PAGE_CONTENT_PADDING = `${UI}-detail-page-content-padding`;

export const APP_LAYOUT = `${UI}-app-layout`;
export const APP_LAYOUT_CONTENT_WRAPPER = `${UI}-app-layout-content-wrapper`;
export const APP_LAYOUT_NAVBAR_CONTENT_WRAPPER = `${UI}-app-layout-navbar-content-wrapper`;
export const APP_LAYOUT_LEFT_PANEL = `${UI}-app-layout-left-panel`;

export const NAVBAR_FULLTEXT = `${UI}-navbar-fulltext`;
export const APP_LAYOUT_BLANK = `${UI}-app-layout-blank`;
export const APP_LAYOUT_BLANK_CONTENT = `${UI}-app-layout-blank-content`;
export const APP_LAYOUT_BLANK_HCENTER = `${UI}-app-layout-blank-hcenter`;
export const APP_LAYOUT_BLANK_VCENTER = `${UI}-app-layout-blank-vcenter`;

export const APP_LAYOUT_TEST_WRAPPER = `${UI}-app-layout-test-wrapper`;
export const APP_LAYOUT_TEST_WRAPPER_BODY = `${UI}-app-layout-test-wrapper-body`;

export const APP_LAYOUT_BASE = `${UI}-app-layout-base`;
export const APP_LAYOUT_WRAPPER = `${UI}-app-layout-wrapper`;
export const APP_LAYOUT_BASE_NAVBAR = `${UI}-app-layout-base-navbar`;
export const APP_LAYOUT_BASE_APP_CONTENT = `${UI}-app-layout-base-app-content`;
export const APP_LAYOUT_BASE_NAVBAR_CONTENT = `${UI}-app-layout-base-navbar-content`;
export const APP_LAYOUT_BASE_NAVBAR_CONTENT_WRAPPER = `${UI}-app-layout-base-navbar-content-wrapper`;
export const APP_LAYOUT_BASE_CONTENT_WRAPPER = `${UI}-app-layout-base-content-wrapper`;
// export const APP_LAYOUT_BASE_CONTENT = `${UI}-app-layout-base-content`;
export const APP_LAYOUT_BASE_HCENTER = `${UI}-app-layout-base-hcenter`;
export const APP_LAYOUT_BASE_VCENTER = `${UI}-app-layout-base-vcenter`;
export const APP_LAYOUT_BASE_LEFT_PANEL = `${UI}-app-layout-base-left-panel`;

export const LIST_HEADER = `${UI}-list-header`;
export const LIST_HEADER_NOT_CHECKABLE = `${UI}-list-header-not-checkable`;
export const LIST_HEADER_INVERSE = `${UI}-list-header-inverse`;
export const LIST_HEADER_CHECK = `${UI}-list-header-check`;
export const LIST_HEADER_CONTENT = `${UI}-list-header-content`;
export const LIST_HEADER_RIGHT = `${UI}-list-header-right`;

export const WYSIWYG_EDITOR = `${UI}-wysiwyg-editor`;
export const WYSIWYG_MENU = `${UI}-wysiwyg-menu`;
export const WYSIWYG_CONTENT = `${UI}-wysiwyg-content`;
export const WYSIWYG_HEADING_SELECT = `${UI}-wysiwyg-heading-select`;

export const DELETED = `${UI}-deleted`;

export const SKELETON = `${UI}-skeleton`;
export const SKELETON_ITEM = `${UI}-skeleton-item`;
export const SKELETON_INVERSE = `${UI}-skeleton-inverse`;

export const DATA_TABLE_EXTRA = `${UI}-data-table-extra`;
export const DATA_TABLE_EXTRA_LEFT = `${UI}-data-table-extra-left`;
export const DATA_TABLE_EXTRA_CONTENT = `${UI}-data-table-extra-content`;
export const DATA_TABLE_EXTRA_TITLE = `${UI}-data-table-extra-title`;
export const DATA_TABLE_EXTRA_RIGHT = `${UI}-data-table-extra-right`;

export const FINAL_TABLE_WRAPPER = `${UI}-final-table-wrapper`;
export const FINAL_TABLE_WHEADER = `${UI}-final-table-wheader`;
export const FINAL_TABLE_WHEADER_TITLE = `${UI}-final-table-wheader-title`;
export const FINAL_TABLE_WHEADER_TITLE_WRAPPER = `${UI}-final-table-wheader-title-w`;
export const FINAL_TABLE_WHEADER_TITLE_TEXT = `${UI}-final-table-wheader-title-t`;
export const FINAL_TABLE_WHEADER_TITLE_ACTION = `${UI}-final-table-wheader-title-a`;
export const FINAL_TABLE = `${UI}-final-table`;
export const FINAL_TABLE_CONTAINER = `${UI}-final-table-container`;
export const FINAL_TABLE_HEADER_CELL = `${UI}-final-table-header-cell`;
export const FINAL_TABLE_HEADER_CELL_CHECK = `${UI}-final-table-check-cell`;
export const FINAL_TABLE_HEADER_CELL_NORMAL = `${UI}-final-table-normal-cell`;
export const FINAL_TABLE_HEADER_CELL_GROUP = `${UI}-final-table-group-cell`;
export const FINAL_TABLE_SORTABLE = `${UI}-final-table-sortable`;
export const FINAL_TABLE_GROUP = `${UI}-final-table-group`;
export const FINAL_TABLE_GROUP_COUNT = `${UI}-final-table-group-count`;
export const FINAL_TABLE_HEADER_SORT = `${UI}-final-table-header-sort`;
export const FINAL_TABLE_HEADER_RESIZER = `${UI}-final-table-header-resizer`;
export const FINAL_TABLE_HEADER_RESIZER_RESIZING = `${UI}-final-table-header-resizer-active`;
export const FINAL_TABLE_SORT_DEPTH = `${UI}-final-table-header-sort-depth`;
export const FINAL_TABLE_HEADER_ICON_ACTION = `${UI}-final-table-header-icon-action`;
export const FINAL_TABLE_AGGREGATE_ICON_ACTION = `${UI}-final-table-aggregate-icon-action`;
export const FINAL_TABLE_AGGREGATE_TRANSPARENT = `${UI}-final-table-aggregate-transparent`;
export const FINAL_TABLE_HEADER_ACTIONS = `${UI}-final-table-header-actions`;
export const FINAL_TABLE_HEADER_ACTIONS_FLOATING = `${UI}-final-table-header-actions-floating`;
export const FINAL_TABLE_BODY_CELL_GROUP_EXP_COL = `${UI}-final-table-body-expcol`;
export const FINAL_TABLE_BODY_CELL_GROUP_CONTENT = `${UI}-final-table-body-grp-c`;
export const FINAL_TABLE_BODY_CELL_GROUP_CONTENT_SKELETON = `${UI}-final-table-body-grp-c-skel`;
export const FINAL_TABLE_LOADING_CONTAINER = `${UI}-final-table-loading-c`;
export const FINAL_TABLE_EXTRA = `${UI}-final-table-extra`;
export const FINAL_TABLE_EXTRA_CHM = `${UI}-final-table-extra-chm`;
export const FINAL_TABLE_EXTRA_LEFT = `${UI}-final-table-extra-left`;
export const FINAL_TABLE_EXTRA_CONTENT = `${UI}-final-table-extra-content`;
export const FINAL_TABLE_EXTRA_RC = `${UI}-final-table-extra-rc`;
export const FINAL_TABLE_EXTRA_RIGHT = `${UI}-final-table-extra-right`;
export const FINAL_TABLE_NO_VERTICAL_SCROLL = `${UI}-final-table-no-vertical-scroll`;
export const FINAL_TABLE_NO_DATA = `${UI}-final-table-no-data`;
export const FINAL_TABLE_GROUPING = `${UI}-final-table-grouping`;
export const FINAL_TABLE_MODE_DEFAULT = `${UI}-final-table-mode-default`;
export const FINAL_TABLE_MODE_INPUT = `${UI}-final-table-mode-input`;
export const FINAL_TABLE_NO_CONTENT = `${UI}-final-table-no-content`;
export const FINAL_TABLE_POSITION_ABSOLUTE = `${UI}-final-table-position-absolute`;
export const FINAL_TABLE_EXTRA_CONTAINER = `${UI}-final-table-extra-container`;
export const FINAL_TABLE_HEADER = `${UI}-final-table-header`;
export const FINAL_TABLE_ROW = `${UI}-final-table-row`;
export const FINAL_TABLE_ROW_KEBAB_SHOWN = `${UI}-final-table-row-kebab-shown`;
export const FINAL_TABLE_ROW_KEBAB = `${UI}-final-table-row_kebab`;
export const FINAL_TABLE_GROUP_ROW = `${UI}-final-table-group-row`;
export const FINAL_TABLE_CONTENT = `${UI}-final-table-content`;
export const FINAL_TABLE_HEADER_CELL_VALUE = `${UI}-final-table-header-cell-value`;
export const FINAL_TABLE_BODY_CELL = `${UI}-final-table-body-cell`;
export const FINAL_TABLE_BODY_GROUP_CELL = `${UI}-final-table-body-group-cell`;
export const FINAL_TABLE_BODY_GROUP_CELL_GRP = `${UI}-final-table-body-group-cell-gpr`;
export const FINAL_TABLE_FOOTER_CELL = `${UI}-final-table-footer-cell`;
export const FINAL_TABLE_BODY_CELL_VALUE = `${UI}-final-table-body-cell-value`;
export const FINAL_TABLE_BODY_CHECK_CELL = `${UI}-final-table-body-check-cell`;
export const FINAL_TABLE_BODY_ACTION_CELL = `${UI}-final-table-body-action-cell`;
export const FINAL_TABLE_COLUMN_FILTER_FORM = `${UI}-final-table-column-filter-form`;
export const FINAL_TABLE_COLUMN_FILTER_FORM_RANGE = `${UI}-final-table-column-filter-form-range`;
export const FINAL_TABLE_COLUMN_FILTER_FORM_BODY = `${UI}-final-table-column-filter-form-body`;
export const FINAL_TABLE_COLUMN_FILTER_FORM_FOOTER = `${UI}-final-table-column-filter-form-footer`;
export const FINAL_TABLE_FOOTER = `${UI}-final-table-footer`;

export const DATA_TABLE = `${UI}-data-table`;
export const DATA_TABLE_NO_VERTICAL_SCROLL = `${UI}-data-table-no-vertical-scroll`;
export const DATA_TABLE_CONTAINER = `${UI}-data-table-container`;
export const DATA_TABLE_NO_DATA = `${UI}-data-table-no-data`;
export const DATA_TABLE_GROUPING = `${UI}-data-table-grouping`;
export const DATA_TABLE_MODE_DEFAULT = `${UI}-data-table-mode-default`;
export const DATA_TABLE_MODE_INPUT = `${UI}-data-table-mode-input`;
export const DATA_TABLE_NO_CONTENT = `${UI}-data-table-no-content`;
export const DATA_TABLE_POSITION_ABSOLUTE = `${UI}-table-position-absolute`;
export const DATA_TABLE_EXTRA_CONTAINER = `${UI}-data-table-extra-container`;
export const DATA_TABLE_HEADER = `${UI}-data-table-header`;
export const DATA_TABLE_ROW = `${UI}-data-table-row`;
export const DATA_TABLE_GROUP_ROW = `${UI}-data-table-group-row`;
export const DATA_TABLE_CONTENT = `${UI}-data-table-content`;
export const DATA_TABLE_HEADER_CELL = `${UI}-data-table-header-cell`;
export const DATA_TABLE_HEADER_GROUP_CELL = `${UI}-data-table-header-group-cell`;
export const DATA_TABLE_HEADER_CELL_SORTABLE = `${UI}-data-table-header-cell-sortable`;
export const DATA_TABLE_HEADER_CELL_VALUE = `${UI}-data-table-header-cell-value`;
export const DATA_TABLE_HEADER_CELL_SORTING = `${UI}-data-table-header-cell-sorting`;
export const DATA_TABLE_HEADER_CHECK_CELL = `${UI}-data-table-header-check-cell`;
export const DATA_TABLE_BODY_CELL = `${UI}-data-table-body-cell`;
export const DATA_TABLE_BODY_GROUP_CELL = `${UI}-data-table-body-group-cell`;
export const DATA_TABLE_BODY_GROUP_CELL_GRP = `${UI}-data-table-body-group-cell-gpr`;
export const DATA_TABLE_FOOTER_CELL = `${UI}-data-table-footer-cell`;
export const DATA_TABLE_FOOTER_CELL_VALUE = `${UI}-data-table-footer-cell-value`;
export const DATA_TABLE_BODY_CELL_VALUE = `${UI}-data-table-body-cell-value`;
export const DATA_TABLE_BODY_CHECK_CELL = `${UI}-data-table-body-check-cell`;
export const DATA_TABLE_BODY_ACTION_CELL = `${UI}-data-table-body-action-cell`;
export const DATA_TABLE_HEADER_CELL_FILTERABLE = `${UI}-data-table-header-cell-filterable`;
export const DATA_TABLE_HEADER_CELL_FILTER = `${UI}-data-table-header-cell-filter`;
export const DATA_TABLE_COLUMN_FILTER_FORM = `${UI}-data-table-column-filter-form`;
export const DATA_TABLE_COLUMN_FILTER_FORM_BODY = `${UI}-data-table-column-filter-form-body`;
export const DATA_TABLE_COLUMN_FILTER_FORM_FOOTER = `${UI}-data-table-column-filter-form-footer`;
export const DATA_TABLE_FOOTER = `${UI}-data-table-footer`;

export const VIRTUAL_LIST = `${UI}-virtual-list`;
export const VIRTUAL_LIST_MODE_DEFAULT = `${UI}-virtual-list-mode-default`;
export const VIRTUAL_LIST_MODE_INPUT = `${UI}-virtual-list-mode-input`;
export const VIRTUAL_LIST_HEADER = `${UI}-virtual-list-header`;
export const VIRTUAL_LIST_CONTENT = `${UI}-virtual-list-content`;
// export const VIRTUAL_LIST_FOOTER = `${UI}-virtual-list-footer`;

export const APP_LAYOUT_VIEW_DETAIL = `${UI}-app-layout-view-detail`;
export const APP_LAYOUT_VIEW_DETAIL_NAVBAR = `${UI}-app-layout-view-detail-navbar`;
export const APP_LAYOUT_VIEW_DETAIL_HEADER = `${UI}-app-layout-view-detail-header`;
export const APP_LAYOUT_VIEW_DETAIL_HEADER_DEFAULT = `${UI}-app-layout-view-detail-header-default`;
export const APP_LAYOUT_VIEW_DETAIL_HEADER_SECONDARY = `${UI}-app-layout-view-detail-header-secondary`;
export const APP_LAYOUT_VIEW_DETAIL_HEADER_LEFT = `${UI}-app-layout-view-detail-header-left`;
export const APP_LAYOUT_VIEW_DETAIL_CONTENT_WRAPPER = `${UI}-app-layout-view-detail-content-wrapper`;
export const APP_LAYOUT_VIEW_DETAIL_CONTENT_WRAPPER_SIDE = `${UI}-app-layout-view-detail-content-wrapper-side`;
export const APP_LAYOUT_VIEW_DETAIL_CONTENT = `${UI}-app-layout-view-detail-content`;
export const APP_LAYOUT_VIEW_DETAIL_HCENTER = `${UI}-app-layout-view-detail-hcenter`;
export const APP_LAYOUT_VIEW_DETAIL_VCENTER = `${UI}-app-layout-view-detail-vcenter`;

export const BLOCK = `${UI}-block`;
export const BLOCK_HEADER = `${UI}-block-header`;
export const BLOCK_HEADER_TITLE = `${UI}-block-header-title`;
export const BLOCK_HEADER_TITLE_INACTIVE = `${UI}-block-header-title-inactive`;
export const BLOCK_HEADER_TITLE_NO_WRAP = `${UI}-block-header-title-no-wrap`;
export const BLOCK_HEADER_EXTRA = `${UI}-block-header-extra`;
export const BLOCK_BODY = `${UI}-block-body`;
export const CONTAINER_FULL_HEIGHT = `${UI}-container-full-height`;
export const CONTAINER_MAX_HEIGHT = `${UI}-container-max-height`;

export const LIST_ITEM = `${UI}-list-item`;
export const LIST_ITEM_CHECKABLE = `${UI}-list-item-checkable`;
export const LIST_ITEM_HIGHLIGHTED = `${UI}-list-item-highlighted`;
export const LIST_ITEM_EXTRA = `${UI}-list-item-extra`;
export const LIST_ITEM_CHECKER_CONT = `${UI}-list-item-checker-cont`;
export const LIST_ITEM_BODY = `${UI}-list-item-body`;
export const LIST_ITEM_TITLE = `${UI}-list-item-title`;
export const LIST_ITEM_HEADER = `${UI}-list-item-header`;
export const LIST_ITEM_HAS_HEADER = `${UI}-list-item-has-header`;
export const LIST_ITEM_DEFAULT = `${UI}-list-item-intent-default`;
export const LIST_ITEM_DEFAULT_INVERSE = `${UI}-list-item-intent-default-inverse`;
export const LIST_ITEM_SECONDARY = `${UI}-list-item-intent-secondary`;
export const LIST_ITEM_DANGER = `${UI}-list-item-intent-danger`;
export const LIST_ITEM_SUCCESS = `${UI}-list-item-intent-success`;
export const LIST_ITEM_INACTIVE = `${UI}-list-item-intent-inactive`;
export const LIST_ITEM_WARNING = `${UI}-list-item-intent-warning`;

export const EXTRA_ACTIONS_SIZE_1 = `${UI}-extra-actions-size-1`;

export const HORIZONTAL_LOADER = `${UI}-horizontal-loader`;
export const HORIZONTAL_LOADER_INNER = `${UI}-horizontal-loader-inner`;
export const HORIZONTAL_LOADER_TRANSPARENT = `${UI}-horizontal-loader-transparent`;

export const SPINNER = `${UI}-spinner`;
export const SPINNER_TRACK = `${UI}-spinner-track`;
export const SPINNER_HEAD = `${UI}-spinner-head`;

export const TAG = `${UI}-tag`;
export const TAG_HAS_MENU = `${UI}-tag-has-menu`;
export const TAG_CLOSABLE = `${UI}-tag-closable`;
export const TAG_CLOSE_ACTION = `${UI}-tag-close-action`;
export const TAG_COLOR = `${UI}-tag-color-`;
export const TAG_HAS_CONTENT = `${UI}-tag-has-content`;
export const TAG_SIZE_DEFAULT = `${UI}-tag-size-default`;
// export const TAG_SIZE_LG = `${UI}-tag-size-lg`;
export const TAG_WRAPPER = `${UI}-tag-wrapper`;
export const TAG_ICON_LEFT = `${UI}-tag-icon-left`;
export const TAG_ICON_RIGHT = `${UI}-tag-icon-right`;
export const TAG_STRONG = `${UI}-tag-strong`;
export const TAG_ITALIC = `${UI}-tag-italic`;
export const TAG_INACTIVE = `${UI}-tag-inactive`;
export const TAG_PRIMARY = `${UI}-tag-primary`;
export const TAG_DEFAULT = `${UI}-tag-default`;
export const TAG_SECONDARY = `${UI}-tag-secondary`;
export const TAG_DANGER = `${UI}-tag-danger`;
export const TAG_WARNING = `${UI}-tag-warning`;
export const TAG_SUCCESS = `${UI}-tag-success`;
export const TAG_MAX_HEIGHT = `${UI}-tag-max-height`;
export const TAG_INVERSE = `${UI}-tag-inverse`;
export const TAG_SIZE_LG = `${UI}-tag-size-lg`;
export const TAG_TYPE_OUTLINE = `${UI}-tag-type-outline`;

// TagGroup
export const TAG_GROUP = `${UI}-tag-group`;

export const ACTIVE = `${UI}-active`;
export const MAYBE_ACTIVE = `${UI}-maybe-active`;

export const BADGE = `${UI}-badge`;
export const BADGE_COLOR = `${UI}-badge-color-`;
export const BADGE_INACTIVE = `${UI}-badge-inactive`;
export const BADGE_PRIMARY = `${UI}-badge-primary`;
export const BADGE_DEFAULT = `${UI}-badge-default`;
export const BADGE_SECONDARY = `${UI}-badge-secondary`;
export const BADGE_DANGER = `${UI}-badge-danger`;
export const BADGE_WARNING = `${UI}-badge-warning`;
export const BADGE_SUCCESS = `${UI}-badge-success`;
export const BADGE_SECTION = `${UI}-badge-section`;
export const BADGE_SUBSECTION = `${UI}-badge-subsection`;

export const TEXT = `${UI}-text`;

export const TYPOGRAPHY = `${UI}-typography`;
export const TYPOGRAPHY_ICON = `${UI}-typography-icon`;
export const TYPOGRAPHY_ICON_SPACE = `${UI}-typography-icon-space`;
export const TYPOGRAPHY_STRONG = `${UI}-typography-strong`;
export const TYPOGRAPHY_ITALIC = `${UI}-typography-italic`;
export const TYPOGRAPHY_UNDERLINE = `${UI}-typography-underline`;
export const TYPOGRAPHY_DISABLED = `${UI}-typography-disabled`;
export const TYPOGRAPHY_PRIMARY = `${UI}-typography-primary`;
export const TYPOGRAPHY_INHERIT = `${UI}-typography-inherit`;
export const TYPOGRAPHY_DANGER = `${UI}-typography-danger`;
export const TYPOGRAPHY_WARNING = `${UI}-typography-warning`;
export const TYPOGRAPHY_SUCCESS = `${UI}-typography-success`;
export const TYPOGRAPHY_INACTIVE = `${UI}-typography-inactive`;
export const TYPOGRAPHY_INVERSE = `${UI}-typography-inverse`;
export const TYPOGRAPHY_DEFAULT = `${UI}-typography-default`;
export const TYPOGRAPHY_SECONDARY = `${UI}-typography-secondary`;

export const TYPOGRAPHY_SIZE_INHERIT = `${UI}-typography-size-inherit`;
export const TYPOGRAPHY_SIZE_NORMAL = `${UI}-typography-size-normal`;
export const TYPOGRAPHY_SIZE_SMALL = `${UI}-typography-size-small`;

export const INTENT_PRIMARY = `${UI}-intent-primary`;
export const INTENT_DANGER = `${UI}-intent-danger`;
export const INTENT_WARNING = `${UI}-intent-warning`;
export const INTENT_SUCCESS = `${UI}-intent-success`;

export const TABLE = `${UI}-table`;
export const TABLE_CELL_ACTION = `${UI}-table-cell-action`;
export const TABLE_WRAPPER = `${UI}-table-wrapper`;
export const TABLE_HAS_FOOTER = `${UI}-table-has-footer`;
export const TABLE_ALIGN_LEFT = `${UI}-table-align-left`;
export const TABLE_ALIGN_RIGHT = `${UI}-table-align-right`;
export const TABLE_ALIGN_CENTER = `${UI}-table-align-center`;
export const TABLE_MODE_DEFAULT = `${UI}-table-mode-default`;
export const TABLE_MODE_EDIT = `${UI}-table-mode-edit`;
export const TABLE_MODE_VIEW = `${UI}-table-mode-view`;
export const TABLE_MODE_INPUT = `${UI}-table-mode-input`;

export const TABS = `${UI}-tabs`;
export const TABS_DEFAULT = `${UI}-tabs-default`;
export const TABS_PROCESS = `${UI}-tabs-process`;

export const TAB = `${UI}-tab`;
export const TAB_WRAPPER = `${UI}-tab-wrapper`;
export const TAB_DISABLED = `${UI}-tab-disabled`;
export const TAB_ACTIVE = `${UI}-tab-active`;

export const FORM_GRID = `${UI}-form-grid`;
export const FORM_GRID_SIZE_DEFAULT = `${UI}-form-grid-default`;
export const FORM_GRID_SIZE_MD = `${UI}-form-grid-md`;
export const FORM_GRID_SIZE_LG = `${UI}-form-grid-lg`;
export const FORM_GRID_SIZE_XL = `${UI}-form-grid-xl`;
export const FORM_GRID_SIZE_XXL = `${UI}-form-grid-xxl`;
export const FORM_GRID_SIZE_DBLCOL = `${UI}-form-grid-dbl-col`;
export const FORM_MULTI_SELECT = `${UI}-form-multi-select-values`;
export const FORM_MULTI_LIST = `${UI}-form-multi-select-list`;
export const FORM_MULTI_LIST_INLINE = `${UI}-form-multi-select-list-inline`;
export const EDIT_MODE = `${UI}-edit-mode`;

export const LABEL_VALUE_LIST = `${UI}-label-value-list`;
export const LABEL_VALUE_LIST_FULL = `${UI}-label-value-list-full`;
export const LABEL_VALUE_LIST_ITEM_LABEL = `${UI}-label-value-list-item-label`;
export const LABEL_VALUE_LIST_ITEM_VALUE = `${UI}-label-value-list-item-value`;
export const LABEL_VALUE_LIST_ITEM_VALUE_RIGHT = `${UI}-label-value-list-item-value-right`;

export const LABEL_VALUE = `${UI}-label-value`;
export const LABEL_VALUE_INLINE = `${UI}-label-value-inline`;
export const LABEL_VALUE_LAST_ITEM = `${UI}-label-value-last-item`;
export const LABEL_VALUE_CONTENT = `${UI}-label-value-content`;
export const LABEL_VALUE_CENTRED = `${UI}-label-value-centred`;

export const LABEL = `${UI}-label`;
export const LABEL_DEFAULT = `${UI}-label-default`;
export const LABEL_MAYBE_REQUIRED = `${UI}-label-maybe-required`;

export const TOAST_MANAGER = `${UI}-toast-manager`;
export const TOAST = `${UI}-toast`;
export const TOAST_FADE_IN = `${UI}-toast--fade-in`;
export const TOAST_FADE_OUT = `${UI}-toast--fade-out`;
export const TOAST_ICON = `${UI}-toast__icon`;
export const TOAST_BODY = `${UI}-toast__body`;
export const TOAST_CONTENT = `${UI}-toast__body__content`;
export const TOAST_TITLE = `${UI}-toast__body__title`;
export const TOAST_MESSAGE = `${UI}-toast__body__message`;

// Forms
export const FORM_NO_FORM_INPUT = `${UI}-form-no-form-input`;
export const FORM_GROUP_FORM = `${UI}-form-group-form`;
export const FORM_GROUP = `${UI}-form-group`;
export const FORM_GROUP_CONTENT = `${UI}-form-group-content`;
export const FORM_GROUP_HAS_HELPER_TEXT = `${UI}-form-group-has-helper-text`;
export const FORM_GROUP_INLINE = `${UI}-form-group-inline`;
export const RF_FORM_GROUP = 'rf-form-group';
export const RF_DISABLED = 'rf-disabled';
export const RF_READONLY = 'rf-readonly';
export const RF_ERROR = 'rf-error';
export const RF_NO_ERROR_SPACE = 'rf-no-error-space';
export const RF_ACTIVE = 'rf-active';
export const RF_WARNING = 'rf-warning';
export const RF_HELPER_TEXT = 'rf-helper-text';

export const RF_POPUP_TRIGGER = 'rf-popup-trigger';
export const RF_REQUIRED = 'rf-required';
export const RF_FILLED = 'rf-filled';

export const NO_DATA = `${UI}-no-data`;

//Tile
export const TILE = `${UI}-tile`;
export const TILE_BODY = `${UI}-tile-body`;
export const TILE_CHILD_WRAPPER = `${UI}-tile-child-wrapper`;
export const TILE_HEADER = `${UI}-tile-header`;
export const TILE_SUB_HEADER = `${UI}-tile-sub-header`;

// Confirm dialog
export const CONFIRM_DIALOG = `${UI}-confirm-dialog`;
export const CONFIRM_DIALOG_TITLE_OR_MESSAGE = `${UI}-confirm-dialog-title-or-message`;
export const CONFIRM_DIALOG_MESSAGE = `${UI}-confirm-dialog-message`;
export const CONFIRM_DIALOG_REVERSE_BUTTONS = `${UI}-confirm-dialog-reverse-buttons`;
export const CONFIRM_DIALOG_BODY = `${UI}-confirm-dialog-body`;
export const CONFIRM_DIALOG_BODY_LEFT = `${UI}-confirm-dialog-body-left`;

//TestovaciProstrediBar
export const TEST_ENVIRONMENT_BAR = `${UI}-test-environment-bar`;

//Pagination
export const PAGINATION = `${UI}-pagination`;
export const PAGINATION_PAGE_INPUT = `${UI}-pagination-page-input`;
export const PAGINATION_PAGE_BUTTON = `${UI}-pagination-page-button`;
export const PAGINATION_INPUT_ERROR = `${UI}-pagination-input-error`;
export const PAGINATION_INFO = `${UI}-pagination-info`;
export const PAGINATION_BUTTON_CONTAINER = `${UI}-pagination-button-container`;
export const PAGINATION_TABLE = `${UI}-pagination-table`;
export const PAGINATION_SHADOW = `${UI}-pagination-shadow`;
export const PAGINATION_NO_DATA = `${UI}-pagination-no-data`;

//TimeLine
export const TIMELINE = `${UI}-timeline`;
export const TIMELINE_VERTICAL = `${UI}-timeline-vertical`;
export const TIMELINE_STATUS = `${UI}-timeline-status`;
export const TIMELINE_STATUS_COMPLETED = `${UI}-timeline-status-completed`;
export const TIMELINE_STATUS_SEPARATOR = `${UI}-timeline-status-separator`;
export const TIMELINE_STATUS_SEPARATOR_COMPLETED = `${UI}-timeline-status-separator-completed`;
export const TIMELINE_CONTENT = `${UI}-timeline-content`;
export const TIMELINE_ROW = `${UI}-timeline-row`;
export const TIMELINE_HEAD = `${UI}-timeline-head`;

//ImageGalleryInput
export const IMAGE_GALLERY_INPUT = `${UI}-image-gallery-input`;
export const DROPZONE = `${UI}-dropzone`;
export const THUMB_BUTTON = `${UI}-thumb-button`;
export const EMPTY_DROPZONE = `${UI}-empty-dropzone`;
export const DRAGGING_DROPZONE = `${UI}-dragging-dropzone`;
export const DRAG_TEXT = `${UI}-drag-text`;
export const THUMBS_CONTAINER = `${UI}-thumbs-container`;
export const THUMB = `${UI}-thumb`;
export const THUMB_NAME = `${UI}-thumb-name`;
export const THUMB_INNER = `${UI}-thumb-inner`;
export const THUMB_INNER_SPINNER = `${UI}-thumb-inner-spinner`;
export const THUMB_DELETE = `${UI}-thumb-delete`;
export const VIDEO_THUMB = `${UI}-video-thumb`;

//Note
export const NOTE = `${UI}-note`;

export const ABOUT_DIALOG = `${UI}-about-dialog`;
export const ABOUT_DIALOG_CONTAINER = `${UI}-about-dialog-container`;
export const ABOUT_DIALOG_DESCRIPTION = `${UI}-about-dialog-description`;

//SliderInput
export const RANGE_SLIDER = `${UI}-range-slider`;
export const SLIDER = `${UI}-slider`;
export const SLIDER_INPUT_WRAPPER = `${UI}-slider-input-wrapper`;
export const SLIDER_CONTROL_WRAPPER = `${UI}-slider-control-wrapper`;
export const SLIDER_INPUT = `${UI}-slider-input`;
export const SLIDER_RAIL = `${UI}-slider-rail`;
export const SLIDER_INNER_RAIL = `${UI}-slider-inner-rail`;
export const SLIDER_CONTROL = `${UI}-slider-control`;
export const SLIDER_DISABLED_CONTROL = `${UI}-slider-disabled-control`;
export const SLIDER_NUMBER_INPUT_LEFT = `${UI}-slider-number-input-left`;
export const SLIDER_NUMBER_INPUT_RIGHT = `${UI}-slider-number-input-right`;
export const SLIDER_WRAPPER = `${UI}-slider-wrapper`;
export const SLIDER_SHOW_INPUT_BELOW = `${UI}-slider-show-input-below`;
export const SLIDER_SHOW_INPUT_BELOW_WRAPPER = `${UI}-slider-show-input-below-wrapper`;

//PasswordInput
export const PASSWORD_INPUT = `${UI}-password-input`;
export const PASSWORD_INPUT_INPUT = `${UI}-password-input-input`;

//BadgeCount
export const BADGE_COUNT = `${UI}-badge-count`;
export const BADGE_COUNT_INSETTED = `${UI}-badge-count-insetted`;
export const BADGE_COUNT_DEFAULT = `${UI}-badge-count-default`;
export const BADGE_COUNT_DANGER = `${UI}-badge-count-danger`;
export const BADGE_COUNT_WARNING = `${UI}-badge-count-warning`;
export const BADGE_COUNT_SUCCESS = `${UI}-badge-count-success`;
export const BADGE_COUNT_SECONDARY = `${UI}-badge-count-secondary`;
export const BADGE_COUNT_NUMBER = 'count-number';

export const TEXT_AREA_FILL = `${UI}-text-area-fill`;

//Calendar
export const CALENDAR = `${UI}-calendar`;
export const CALENDAR_HEADER = `${UI}-calendar-header`;
export const CALENDAR_FIXED_PLUS = `${UI}-calendar-fixed-plus`;
export const CALENDAR_HEADER_TITLE_ACTIONS = `${UI}-calendar-header-title-actions`;
export const CALENDAR_HEADER_DAY_TITLE_COLUMNS = `${UI}-calendar-header-day-title-columns`;
export const CALENDAR_HEADER_DAY_TITLE_COLUMN = `${UI}-calendar-header-day-title-column`;
export const CALENDAR_HEADER_DAY_TITLE_COLUMN_ACTIVE = `${UI}-calendar-header-day-title-column_active`;
export const CALENDAR_HEADER_DAY_EVENT_COLUMNS = `${UI}-calendar-header-day-event-columns`;
export const CALENDAR_HEADER_DAY_EVENT_COLUMN = `${UI}-calendar-header-day-event-column`;
export const CALENDAR_EVENT = `${UI}-calendar-event`;
export const CALENDAR_EVENT_SELECTED = `${UI}-calendar-event-selected`;
export const CALENDAR_EVENT_CLONE = `${UI}-calendar-event-clone`;
export const CALENDAR_EVENT_CLONE_SYMBOL = `${UI}-calendar-event-clone-symbol`;
export const CALENDAR_EVENT_ACTIVE = `${UI}-calendar-event-active`;
export const CALENDAR_EVENT_INLINE = `${UI}-calendar-event-inline`;
export const CALENDAR_EVENT_ORIGINAL_POSITION = `${UI}-calendar-event-original-position`;
export const CALENDAR_EVENT_BODY = `${UI}-calendar-event-body`;
export const CALDENDAR_EVENT_BODY_SMALL = `${UI}-calendar-event-body-small`;
export const CALEDNAR_EVENT_BODY_MEDIUM = `${UI}-calendar-event-body-medium`;
export const CALEDNAR_EVENT_DISABLED = `${UI}-calendar-event-disabled`;
export const CALEDNAR_EVENT_ENABLED = `${UI}-calendar-event-enabled`;
export const CALENDAR_EVENT_HANDLE_UP = `${UI}-calendar-event-handle-up`;
export const CALENDAR_EVENT_HANDLE_DOWN = `${UI}-calendar-event-handle-down`;
export const CALENDAR_EVENT_TEMP = `${UI}-calendar-event-temp`;
export const CALENDAR_EVENT_DRAGGING = `${UI}-calendar-event-dragging`;
export const CALENDAR_EVENT_TITLE = `${UI}-calendar-event-title`;
export const CALENDAR_EVENT_DESCRIPTION = `${UI}-calendar-event-description`;
export const CALENDAR_EVENT_TIME = `${UI}-calendar-event-time`;
const CALENDAR_EVENT_COLOR_SCHEME = `${UI}-calendar-event-color-scheme`;
export const getCaledarEventColorScheme = (colorSchemeIndex: number) =>
  `${CALENDAR_EVENT_COLOR_SCHEME}-${colorSchemeIndex}`;
const CALENDAR_EVENT_CUSTOM_COLOR = `${UI}-calendar-event-custom`;
export const getCaledarEventCustomColor = (color: string) =>
  `${CALENDAR_EVENT_CUSTOM_COLOR}-${color}`;
export const CALENDAR_BODY = `${UI}-calendar-body`;
export const CALENDAR_COLUMN = `${UI}-calendar-column`;
export const CALENDAR_WEEKEND_COLUMN = `${UI}-calendar-weekend-column`;
export const CALENDAR_ITEM = `${UI}-calendar-item`;
export const CALENDAR_ITEM_PART = `${UI}-calendar-item-part`;

export const CALENDAR_TITLE = `${UI}-calendar-title`;
export const CALENDAR_DAY_TITLE = `${UI}-calendar-day-title`;
export const CALENDAR_WEEK_DAY_TITLE = `${UI}-calendar-week-day-title`;
export const CALENDAR_DAY_EXTRA = `${UI}-calendar-day-extra`;
export const CALENDAR_FULL_DAY_EVENT = `${UI}-calendar-full-day-event`;
export const CALENDAR_FULL_DAY_EVENT_TITLE = `${UI}-calendar-full-day-event-title`;
export const CALENDAR_EVENT_TOOLTIP = `${UI}-calendar-event-tooltip`;
export const CALENDAR_EVENT_TOOLTIP_TITLE = `${UI}-calendar-event-tooltip-title`;
export const CALENDAR_EVENT_TOOLTIP_TIMERANGE = `${UI}-calendar-event-tooltip-timerange`;
export const CALENDAR_EVENT_TOOLTIP_DESCRIPTION = `${UI}-calendar-event-tooltip-description`;
export const CALENDAR_HOURS_LIST_COLUMN = `${UI}-calendar-hours-list-column`;
export const CALENDAR_HOURS_LIST_ITEM = `${UI}-calendar-hours-list-item`;
export const CALENDAR_TIME_LINE = `${UI}-calendar-time-line`;
export const CALENDAR_TIME_LINE_CURRENT_DAY = `${UI}-calendar-time-line-current-day`;

// ColorSelect
export const COLOR_SELECT_WRAPPER = `${UI}-color-select-wrapper`;
export const COLOR_SELECT = `${UI}-color-select`;
export const COLOR_SELECT_CURRENT_COLOR = `${UI}-color-select-current-color`;

// FormDetailComponent
export const FORM_DETAIL_COMPONENT = `${UI}-form-detail-component`;

// DetailMenu
export const DETAIL_MENU = `${UI}-detail-menu`;
export const DETAIL_MENU_LABEL = `${UI}-detail-menu-label`;
export const DETAIL_MENU_ITEM = `${UI}-detail-menu-item`;
export const DETAIL_MENU_ITEM_ACTIVE = `${UI}-detail-menu-item-active`;

// Breadcrumbs
export const BREADCRUMBS = `${UI}-breadcrumbs`;
export const BREADCRUMB = `${UI}-breadcrumb`;
export const BREADCRUMB_ICON = `${UI}-breadcrumb-icon`;
export const BREADCRUMB_INTERACTIVE = `${UI}-breadcrumb-interactive`;

// Tiles
export const TILE_DANGER = `${UI}-tile-danger`;
export const TILE_SUCCESS = `${UI}-tile-success`;
export const TILE_WARNING = `${UI}-tile-warning`;
export const TILE_INACTIVE = `${UI}-tile-inactive`;
export const TILE_TITLE_DANGER = `${UI}-tile-title-danger`;
export const TILE_TITLE_SUCCESS = `${UI}-tile-title-success`;
export const TILE_TITLE_WARNING = `${UI}-tile-title-warning`;
export const TILE_TITLE_INACTIVE = `${UI}-tile-title-inactive`;
